import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { ArrowUpCircle, MinusCircle, ArrowDownCircle } from 'lucide-react';

const EditTaskDialog = ({ open, onOpenChange, task, setTask, onSubmit }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="surface-card border-0 shadow-xl max-h-[90vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle style={{ fontFamily: 'Outfit, sans-serif' }}>Edit Request</DialogTitle>
        <DialogDescription>Update the details of this help request.</DialogDescription>
      </DialogHeader>
      {task && (
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label>{"What's needed?"}</Label>
            <Input data-testid="edit-task-title" value={task.title} onChange={(e) => setTask({ ...task, title: e.target.value })} className="rounded-xl" required />
          </div>
          <div className="space-y-2">
            <Label>Details</Label>
            <Textarea data-testid="edit-task-desc" value={task.description || ''} onChange={(e) => setTask({ ...task, description: e.target.value })} className="resize-none rounded-xl" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-2">
              <Label>Priority</Label>
              <Select value={task.priority || 'medium'} onValueChange={(val) => setTask({ ...task, priority: val })}>
                <SelectTrigger className="rounded-xl"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="high"><span className="flex items-center gap-2"><ArrowUpCircle className="w-3.5 h-3.5 text-rose-500" /> High</span></SelectItem>
                  <SelectItem value="medium"><span className="flex items-center gap-2"><MinusCircle className="w-3.5 h-3.5 text-amber-500" /> Medium</span></SelectItem>
                  <SelectItem value="low"><span className="flex items-center gap-2"><ArrowDownCircle className="w-3.5 h-3.5 text-sky-500" /> Low</span></SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label>Due date</Label>
              <Input type="date" value={task.due_date || ''} onChange={(e) => setTask({ ...task, due_date: e.target.value })} className="rounded-xl" />
            </div>
          </div>
          <Button type="submit" className="w-full btn-primary" data-testid="save-edit-task-btn">Save Changes</Button>
        </form>
      )}
    </DialogContent>
  </Dialog>
);

export default EditTaskDialog;
